module.exports = __webpack_public_path__ + "img/business.79643c6a.png";